/** Task analytics API calculation mode */
export enum TaskAnalyticsModeEnum {
  /** Compute by balance report */
  BY_BALANCE_REPORT = 'BY_BALANCE_REPORT',
  /** Compute by payment calendar */
  BY_PAYMENT_CALENDAR = 'BY_PAYMENT_CALENDAR',
  /** Compute by deals */
  BY_DEALS = 'BY_DEALS',
}